<template>
  <div id="app" :class="language">
    <headBar :show-right-menu="showRightMenu"
             class="head-bar" ref="headBar" @menu-click="menuClick"></headBar>
    <el-drawer
      title="菜单"
      class="drawer-custom-class1"
      :visible.sync="showRightMenu"
      direction="rtl"
      custom-class="right-menu"
      size="23%"
      :modal="false"
      :with-header="false">
     <menuList class="menu-list" menu-name="mainMenu" @open-second-menu="openSecondMenu"></menuList>
    </el-drawer>
    <el-drawer
      class="drawer-custom-class"
      title="菜单"
      :visible.sync="showSecondMenu"
      direction="rtl"
      custom-class="second-menu"
      size="30%"
      :modal="false"
      :with-header="false"
      @closed="showRightMenu=false"
    >
      <menuList class="menu-list" :menu-name="secondMenuName"
                @close-second-menu="showSecondMenu=false"></menuList>
    </el-drawer>
    <div class="app-wrapper">
      <router-view/>
    </div>
  </div>
</template>

<script>
import headBar from './components/headBar';
import menuList from './components/menuList';

export default {
  name: 'App',
  components: { headBar, menuList },
  data() {
    return {
      showRightMenu: false,
      showSecondMenu: false,
      secondMenuName: 'about',
    };
  },
  computed: {
    language() {
      return this.$store.getters.language;
    },
    globalTransition() {
      return this.$store.getters.globalTransition ? 'global-i18n-hide' : 'global-i18n-not-hide';
    },
  },
  methods: {
    menuClick() {
      this.showRightMenu = !this.showRightMenu;
      if (!this.showRightMenu) {
        this.showSecondMenu = false;
      }
    },
    openSecondMenu(event) {
      this.secondMenuName = event;
      this.showSecondMenu = true;
    },
  },
};
</script>

<style>
  body{
    margin:0;/*消除浏览器自带样式*/
  }
</style>
<style lang="scss" scoped>
  @import "assets/font/font.css";
  #app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;height: auto;
}
  .zh{
    font-family: 'NotoSansHans', 'Avenir', Helvetica, Arial, sans-serif!important;
  }
  .en{
    font-family: 'Helvetica Neue', 'Avenir', Helvetica, Arial, sans-serif!important;
  }
  .app-wrapper {
    position: static;
    height: calc(100% - 100px);
    min-width: 600px;
    width: 100%;
  }
  .head-bar{
    width: 100%;
    background-color: #000;
    height: 100px;
    position: sticky;
    z-index: 2010;
  }
.menu-list{
  height: 100%;
  width: 100%;
}

</style>
<style>
  .right-menu{
   /* top:100px!important;*/
    z-index:2001!important;
  }
  .el-drawer__wrapper{
    z-index:1000!important;
  }
  .second-menu{
  /*  top:100px!important;*/
    z-index:1001!important;
  }
  .drawer-custom-class{
   right: 23%!important;
  }
  .drawer-custom-class1{
  }
</style>



// WEBPACK FOOTER //
// src/App.vue